import React from 'react';
import './searchBar.scss';
import { useTranslation } from 'react-i18next';

type SearchBarProps = {
    setSearchedValue: Function,
}

const SearchBar = (props: SearchBarProps) => {
    const { t } = useTranslation();
    const { setSearchedValue } = props;
    const handleChangeEvent = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchedValue(event.target.value)
    }

    return (
        <div className='searchBar'>
            <input id='searchInput' type='text' title={t('TS_core:Search')} placeholder={t('TS_core:Search')} onChange={handleChangeEvent}  />
        </div>
    )
}

export default SearchBar;
